import React, { useCallback } from 'react';
import Card from 'components/Card';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';
import { DataForm, Input } from 'components/formik_inputs';
import { PermissionContext } from 'hoc/withPermission';
import { useHistory, useLocation, useParams } from 'react-router';
import Button from 'components/common/buttons/Button';
import { usePraticalField } from 'curricula/pratical-field/hooks';
import PraticalFieldService from 'curricula/pratical-field/services';
import { toast } from 'react-toastify';
import { nativeGet as get } from 'utils';

const PraticalFieldFormPage = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const history = useHistory();
  const edit = location.pathname.includes('edit');

  const { data: PraticalField } = usePraticalField(+id);

  const savePraticalField = useCallback(
    async (values) => {
      if (edit) {
        await PraticalFieldService.update(+id, values);

        toast.success('Campo de prática editado com sucesso.');
      } else {
        const { id: newId } = await PraticalFieldService.create(values);

        toast.success('Campo de prática criado com sucesso.');
        history.push(`/campos-pratica/${newId}/edit`);
      }
    },
    [id]
  );

  const handleDelete = useCallback(async () => {
    try {
      await PraticalFieldService.delete(+id);

      toast.success('Campo de prática excluído com sucesso.');
      history.push('/campos-pratica');
    } catch (err) {
      const error = get(err, 'response.data.detail');
      toast.error(error || 'Ocorreu um erro ao remover o campo de prática.');
    }
  }, [id]);

  return (
    <Card title={`${edit ? 'Editar' : 'Cadastrar'} campo de prática`}>
      <DataForm
        initialValues={edit ? PraticalField : { name: '', accounting_tag: '' }}
        onSubmit={savePraticalField}
        autoSetErrors
        enableReinitialize
        submitOnChange={undefined}
      >
        <>
          <div>
          <Input name="name" label="Nome" required />
          <Input name="accounting_tag" label="Código do Centro de Custo" />
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: '20px',
            }}
          >
            <Button onClick={() => history.push('/campos-pratica')}>Voltar</Button>
            <div>
              <PermissionContext.Consumer>
                {({ hasPermission }) =>
                  hasPermission('academico.delete_praticalfield') &&
                  edit && (
                    <ButtonWithConfirmation
                      action="danger"
                      confirmationText="Deseja excluir permanentemente esse Campo de Prática ?"
                      onClick={handleDelete}
                    >
                      Excluir
                    </ButtonWithConfirmation>
                  )
                }
              </PermissionContext.Consumer>
              <Button type="submit">Salvar</Button>
            </div>
          </div>
        </>
      </DataForm>
    </Card>
  );
};

export default PraticalFieldFormPage;
